
import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import { useCalcularPrecios, separadorMillares } from "../../../hooks";
import { SelectSencillo, TextFormField, ViewPreciosPorRol } from "../../components";
import { coloresCarrito } from "../../../data";
import { buscarProductoColor } from "../../../helpers/FormulariosCarrito";

import Swal from "sweetalert2";





export const FormularioCantidadx50 = ({ formCarrito, setFormCarrito, funcionAgregar, poducto, 
                                        titulo='Agregar Producto', carrito, medida=6 }) => {


    const { calcularPrecioX50U } = useCalcularPrecios();
    const [ precioReal, setPrecioReal ] = useState(0);


    
    useEffect(() => {
        if( formCarrito.color === '' ){
            return;
        }
        const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
        Toast.fire({
            icon: 'question',
            title: 'Los Productos y Colores dependen de disponibilidad de stock'
        });
    }, [formCarrito.color]);




    useEffect( () => {
        if( poducto ) {
            const { cliente, distri, empresa, publicista, precioReal } = calcularPrecioX50U( formCarrito.cantidad, poducto );
            
            setPrecioReal( precioReal - cliente );
            setFormCarrito({
                ...formCarrito,
                totalCliente: Math.ceil(cliente),
                totalDistri: Math.ceil(distri),
                totalEmpresa: Math.ceil(empresa),
                totalPublicista: Math.ceil(publicista),
            });
        }
    }, [poducto, formCarrito.cantidad]);




    const handleInputChange = ({ target }) => {
        setFormCarrito({
            ...formCarrito,
            [target.name]: target.value
        });
    }



    const handleAgregarAlCarro = (e) => {
        e.preventDefault();

        if( formCarrito.cantidad <= 0 ) {
            return Swal.fire('Error', 'Debes Poner Una Cantidad', 'error');
        }

        if( (formCarrito.cantidad % 50) !== 0 ){
            return Swal.fire('Error', 'La Cantidad debe Ser Multiplos de 50 en 50', 'error');
        }

        if( formCarrito.color === '' || !formCarrito.color ) { 
            return Swal.fire('Error', 'Por favor escoger un color', 'error') 
        }

        const itemID = buscarProductoColor(carrito, formCarrito.producto, formCarrito.color);
        funcionAgregar(itemID)
    }

    



    return (

        <form onSubmit={ handleAgregarAlCarro } style={{ width:'100%' }}>
            <Grid container sx={{mt:0}} spacing={2}>
                <Grid item xs={12} sm={medida}>
                    <TextFormField
                        size="small"
                        label={`Cantidad`}
                        type='number'
                        placeholder="Cantidad"
                        name="cantidad"
                        value={formCarrito.cantidad}
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={medida}>
                    <SelectSencillo
                        size="small"
                        label="Color"
                        name="color"
                        value={formCarrito.color}
                        onChange={ handleInputChange } 
                        options={coloresCarrito}
                    />
                </Grid>

            </Grid>

            {/* Mostrar Precio Segun Rol */}
            <ViewPreciosPorRol formCarrito={formCarrito} />

            <Grid container sx={{ mt:1 }} spacing={2}>
                <Grid item xs={12} sm={(precioReal <= 0) ? 12 : medida}>
                    <Button type="submit" color='primary' variant="contained" fullWidth>{ titulo }</Button>
                </Grid>

                {(precioReal > 0) && (
                <Grid item xs={12} sm={medida}>
                    <Button color='secondary' variant="contained" fullWidth>
                        Ahorra { `$${ separadorMillares( precioReal ) }`}
                    </Button>
                </Grid>
                )}
            </Grid>
        </form> 
        
    )
}
